export const AuctionEntryStyle = {
  containerWrapper: {
    height: '100%',
    position: 'relative',
    minHeight: 'calc(100vh - 148px)',
    maxHeight: 'fit-content',

    '@media (min-width: 1200px)': {
      minHeight: 'calc(100vh - 128px)',
    },
  },
};
